<template>
    <transition name="slide">
        <div class="bg-surface-secondary w-100">
            <header class="bg-surface-primary border-bottom">
                <div class="container-fluid py-3">
                    <div class="row align-items-center">
                        <div class="col">
                            <div class="d-flex align-items-center gap-4">
                                <div>
                                    <button type="button" class="btn-close text-xs" @click="$router.go(-1)"></button>
                                </div>
                                <div class="vr opacity-20 my-1"></div>
                                <div>
                                    <h1 class="h4 ls-tight">Cierre diario de {{ id }}</h1>
                                </div>
                            </div>
                        </div>
                        <div class="col-auto" v-if="loading === ''">
                            <div class="hstack gap-2 justify-content-end">
                                <div>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <button @click="PRINT()" type="button" v-bind="attrs" v-on="on"
                                                class="btn btn-primary btn-m">
                                                <small class="d-flex justify-content-center align-items-center">
                                                    <div class="spinner-border spinner-border-sm mb-0" role="status" v-if="print > 0">
                                                        <span class="sr-only">Loading...</span>
                                                    </div>
                                                <i v-else class="bi bi-file-earmark-pdf"></i></small>
                                            </button>
                                        </template>
                                        <small>Descargar PDF</small>
                                    </v-tooltip>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
            <main class="py-6 bg-surface-secondary" id="print">
                <div class="container-fluid vstack gap-5" v-if="loading == 'data'">
                    <div class="w-100 py-3">
                        <div class="text-center">
                            <div class="spinner-border text-primary" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="container-fluid vstack gap-5" v-else>
                    <div class="row">
                        <div class="col-lg-3 mb-3">
                            <div class="card">
                                <div class="card-body">
                                    <div class="d-flex gap-3">
                                        <div class="icon icon-shape rounded-3 bg-orange text-white text-lg">
                                            <i class="bi bi-box"></i>
                                        </div>
                                        <div>
                                            <small class="d-block text-md text-muted">Paquetes</small>
                                            <h5 class="mb-1">{{ data.count_packages }}</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-3 mb-3">
                            <div class="card">
                                <div class="card-body">
                                    <div class="d-flex gap-3">
                                        <div class="icon icon-shape rounded-3 bg-danger text-white text-lg">
                                            <i class="bi bi-box"></i>
                                        </div>
                                        <div>
                                            <small class="d-block text-md text-muted">Paquetes Rechazados</small>
                                            <h5 class="mb-1">{{ data.count_deliver_reject }}</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-3 mb-3">
                            <div class="card">
                                <div class="card-body">
                                    <div class="d-flex gap-3">
                                        <div class="icon icon-shape rounded-3 bg-success text-white text-lg">
                                            <i class="bi bi-box"></i>
                                        </div>
                                        <div>
                                            <small class="d-block text-md text-muted">Paquetes entregados</small>
                                            <h5 class="mb-1">{{ data.count_deliver_complete }}</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-3 mb-3">
                            <div class="card">
                                <div class="card-body">
                                    <div class="d-flex gap-3">
                                        <div class="icon icon-shape rounded-3 bg-dark text-white text-lg">
                                            <i class="bi bi-box"></i>
                                        </div>
                                        <div>
                                            <small class="d-block text-md text-muted">Paquetes pendientes</small>
                                            <h5 class="mb-1">{{ data.count_deliver_pendient }}</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-3 mb-3">
                            <div class="card">
                                <div class="card-body">
                                    <div class="d-flex gap-3">
                                        <div class="icon icon-shape rounded-3 bg-primary text-white text-lg">
                                            <i class="bi bi-people"></i>
                                        </div>
                                        <div>
                                            <small class="d-block text-md text-muted">Clientes</small>
                                            <h5 class="mb-1">{{ data.count_clients }}</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-body p-0">
                            <template>
                                <v-data-table  class="elevation-1"
                                :headers="headers"
                                :items="data.packages"
                                hide-default-footer
                                dense
                                :items-per-page="-1">
                                    <template v-slot:[`item.efectivo`]="{ item }">
                                        $ {{ Number(item.efectivo_usd || 0).toFixed(2) }} <br> ₡ {{ Number(item.efectivo || 0).toFixed(2) }}
                                    </template>
                                    <template v-slot:[`item.tarjeta`]="{ item }">
                                        $ {{ Number(item.tarjeta_usd || 0).toFixed(2) }} <br> ₡ {{ Number(item.tarjeta || 0).toFixed(2) }}
                                    </template>
                                    <template v-slot:[`item.transferencia`]="{ item }">
                                        $ {{ Number(item.transferencia_usd || 0).toFixed(2) }} <br> ₡ {{ Number(item.transferencia || 0).toFixed(2) }}
                                    </template>
                                    <template v-slot:[`item.sinpe_movil`]="{ item }">
                                        ₡ {{ Number(item.sinpe_movil || 0).toFixed(2) }}
                                    </template>
                                    <template slot="body.append">
                                        <tr class="bg-dark">
                                            <td class="text-start text-white">Total</td>
                                            <td class="text-start text-white">
                                                $ {{ Number(efectivo_usd || 0).toFixed(2) }} <br> ₡ {{ Number(efectivo || 0).toFixed(2) }}
                                            </td>
                                            <td class="text-start text-white">
                                                $ {{ Number(tarjeta_usd || 0).toFixed(2) }} <br> ₡ {{ Number(tarjeta || 0).toFixed(2) }}
                                            </td>
                                            <td class="text-start text-white">
                                                $ {{ Number(transferencia_usd || 0).toFixed(2) }} <br> ₡ {{ Number(transferencia || 0).toFixed(2) }}
                                            </td>
                                            <td class="text-start text-white">
                                                ₡ {{ Number(sinpe_movil || 0).toFixed(2) }}
                                            </td>
                                        </tr>
                                    </template>
                                </v-data-table>
                            </template>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    </transition>
</template>
<script>
export default {
    data() {
        return {
            headers: [
                { text: 'GVT', value: 'id', sortable: false },
                { text: 'Efectivo', value: 'efectivo', sortable: false },
                { text: 'Tarjeta', value: 'tarjeta', sortable: false },
                { text: 'Transferencia', value: 'transferencia', sortable: false },
                { text: 'Sinpe movil', value: 'sinpe_movil', sortable: false },
            ],
            data: {
                count_packages: 0,
                count_deliver_reject: 0,
                count_deliver_complete: 0,
                count_deliver_pendient: 0,
                count_clients: 0,
                packages: []
            },
            id: this.$route.params.id,
            loading: '',
            count: 0,
            print: 0,
            efectivo_usd:  0,
            efectivo: 0,
            tarjeta_usd: 0,
            tarjeta: 0,
            transferencia_usd: 0,
            transferencia: 0,
            sinpe_movil: 0,
        }
    },
    mounted() {
        let vue = this
        vue.INIT()
    },
    methods: {
        INIT: function () {
            let vue = this
            vue.loading = 'data'
            axios({url: '/closing/deliver-routes/' + vue.id, method: 'GET' })
                .then((resp) => {
                    vue.data = resp.data
                    vue.data.packages.forEach(item => {
                        vue.efectivo += Number(item.efectivo || 0)
                        vue.efectivo_usd += Number(item.efectivo_usd || 0)
                        vue.tarjeta += Number(item.tarjeta || 0)
                        vue.tarjeta_usd += Number(item.tarjeta_usd || 0)
                        vue.transferencia += Number(item.transferencia || 0)
                        vue.transferencia_usd += Number(item.transferencia_usd || 0)
                        vue.sinpe_movil += Number(item.sinpe_movil || 0)
                    });
                })
                .catch((err) => {
                   let message = err.response ? err.response.data.message : err.message
                        vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                })
                .finally((resp) => {
                    vue.loading = ''
                })
        },
        PRINT(){
            let vue = this
            this.print++
            if(this.print == 1){
                axios({url: '/print/deliver-route/' + this.id + '/detail', method: 'GET', timeout: 60000, responseType: 'blob' })
                .then((response) => {
                    let link = document.createElement('a')
                    link.href = window.URL.createObjectURL(response.data)
                    link.target = '_blank'
                    link.rel = "noopener"
                    link.click()
                    this.print = 0
                })
                .catch((err) => {
                    if (err.code === 'ECONNABORTED') {
                        axios({
                            url: '/job/print/deliver-route/' + this.id + '/detail',
                            method: 'GET' })
                        .then((resp) => {
                            this.$swal({ toast: true, icon: 'success', title: resp.data.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                            this.print = 0
                        })
                        .catch((err) => {
                            this.print = 0
                        })
                    } else {
                        if (err.response.status === 402) {
                            let message = err.response ? err.response.data.message : err.message
                            this.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        } else {
                            this.$swal({ toast: true, icon: 'error', title: err.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        }
                        this.print = 0
                    }
                })
            }
        }
    }
}
</script>
